(() => {
  const container = document.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body');
  const title = container?.querySelector('.shopify-policy__title');
  const copyElement = document.getElementById('DigestiaPolicyCopy');
  if (!container || !body || !title || !copyElement || container.dataset.digestiaPolicyReady) return;
  container.dataset.digestiaPolicyReady = 'true';
  let copy;
  try { copy = JSON.parse(copyElement.textContent); } catch { return; }
  const kind = location.pathname.includes('terms-of-service') ? 'terms' : location.pathname.includes('privacy-policy') ? 'privacy' : 'other';
  container.classList.add('dg-native-policy', `dg-native-policy--${kind}`);
  container.id ||= 'DigestiaPolicyTop';
  if (copy[kind]) {
    const eyebrow = document.createElement('p');
    eyebrow.className = 'dg-native-policy__eyebrow';
    eyebrow.textContent = copy[kind].eyebrow;
    title.prepend(eyebrow);
    const intro = document.createElement('p');
    intro.className = 'dg-native-policy__intro';
    intro.textContent = copy[kind].intro;
    title.append(intro);
  }
  if (kind === 'terms') {
    const heading = title.querySelector('h1');
    const words = heading?.textContent.match(/^(.*\s)(\S+)\s*$/);
    if (heading && words) {
      const emphasis = document.createElement('em');
      emphasis.textContent = words[2];
      heading.replaceChildren(document.createTextNode(words[1]), emphasis);
    }
  }
  const content = body.querySelector('.rte') || body;
  let headings = [...content.querySelectorAll('h2')].filter(item => item.textContent.trim());
  if (headings.length < 2) headings = [...content.querySelectorAll('h2,h3')].filter(item => item.textContent.trim());
  if (headings.length < 2) {
    headings = [...content.querySelectorAll('strong,b')].filter(item => /^(section\s+\d+\s*[-–—:]|overview$)/i.test(item.textContent.trim()));
    headings.forEach(heading => {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  }
  if (headings.length > 1) {
    const layout = document.createElement('div');
    layout.className = 'dg-native-policy__layout';
    body.before(layout);
    const nav = document.createElement('nav');
    nav.className = 'dg-native-policy__nav';
    nav.setAttribute('aria-label', copy.contents);
    headings.forEach((heading, index) => {
      heading.id ||= `DigestiaPolicyPart-${index + 1}`;
      heading.dataset.dgPolicyHeading = '';
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      if (!index) link.setAttribute('aria-current', 'location');
      nav.append(link);
    });
    nav.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      nav.querySelectorAll('[aria-current]').forEach(item => item.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'location');
    });
    layout.append(nav, body);
  }
  const back = document.createElement('a');
  back.href = `#${container.id}`;
  back.className = 'dg-native-policy__top';
  const arrow = document.createElement('span');
  arrow.setAttribute('aria-hidden', 'true');
  arrow.textContent = '↑';
  back.append(arrow, document.createTextNode(copy.top));
  body.append(back);
})();
